import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AnalisiPrevista } from "./AnalisiPrevista";
import { ExcelVoceDettaglio, useExcelDettaglio } from "./ExcelVoceDettaglio";
import { RegistroVoce } from "@/components/registroEffettivo/RegistroVoce";
import { RegistrazioneDialog } from "@/components/registroEffettivo/RegistrazioneDialog";
import { canEditRegistro } from "@/components/registroEffettivo/labels";
import { useFunzioniExcel } from "@/components/salE5/labels";
import { LibrettoMisure } from "@/components/salE5/LibrettoMisure";

const useVoceRegistro = (rigaId) => {
  const [data, setData] = useState(null);
  const reload = () => api.get(`/righe/${rigaId}/registro-effettivo`).then((r) => setData(r.data)).catch(() => setData(null));
  useEffect(() => { reload(); }, [rigaId]);
  return { data, reload };
};

export const ExcelVoceTabs = ({ rigaId, foto, note, onDescrizioneChange }) => {
  const { user } = useAuth();
  useFunzioniExcel();
  const canEdit = canEditRegistro(user);
  const { data, setData, err } = useExcelDettaglio(rigaId);
  const reg = useVoceRegistro(rigaId);
  const [dialog, setDialog] = useState(null);
  if (err) return <div className="text-sm text-rose-700 p-4" data-testid="excel-voce-errore">{err}</div>;
  if (!data) return <div className="text-slate-500 p-4">Caricamento dati Excel…</div>;
  const onDescrizione = (r) => {
    setData((d) => ({ ...d, storico: r.storico, voce: { ...d.voce, descrizione: r.descrizione, descrizione_corretta: r.descrizione_corretta } }));
    onDescrizioneChange?.(r.descrizione);
  };
  const onRegistra = canEdit && reg.data ? (tipo, risorsa) => setDialog({ tipo, preset: { rigaId, risorsaId: risorsa?.id, descrizione: risorsa?.descrizione } }) : null;
  return (
    <>
      <Tabs defaultValue="voce" data-testid="excel-voce-tabs">
        <TabsList className="flex flex-wrap h-auto">
          <TabsTrigger value="voce" data-testid="excel-tab-voce">Voce e misurazioni</TabsTrigger>
          <TabsTrigger value="analisi" data-testid="excel-tab-analisi">Analisi prevista</TabsTrigger>
          <TabsTrigger value="misure" data-testid="excel-tab-misure">Misure contabili</TabsTrigger>
          <TabsTrigger value="effettive" data-testid="excel-tab-effettive">Registrazioni effettive</TabsTrigger>
          <TabsTrigger value="foto" data-testid="excel-tab-foto">Foto</TabsTrigger>
          <TabsTrigger value="note" data-testid="excel-tab-note">Note</TabsTrigger>
        </TabsList>
        <TabsContent value="voce"><ExcelVoceDettaglio det={data} onDescrizione={onDescrizione} /></TabsContent>
        <TabsContent value="analisi"><AnalisiPrevista analisi={data.analisi} eff={reg.data?.per_risorsa} onRegistra={onRegistra} /></TabsContent>
        <TabsContent value="misure"><LibrettoMisure rigaId={rigaId} um={data.voce.um} /></TabsContent>
        <TabsContent value="effettive">
          <RegistroVoce data={reg.data} um={data.voce.um} canEdit={canEdit} reload={reg.reload}
            onNew={(tipo) => setDialog({ tipo, preset: { rigaId } })} onEdit={(r) => setDialog({ tipo: r.tipo, initial: r })} />
        </TabsContent>
        <TabsContent value="foto">{foto}</TabsContent>
        <TabsContent value="note">{note}</TabsContent>
      </Tabs>
      {dialog && reg.data && (
        <RegistrazioneDialog open onOpenChange={(o) => !o && setDialog(null)} cantiereId={reg.data.cantiere_id} computoId={reg.data.computo_id}
          tipo={dialog.tipo} initial={dialog.initial} preset={dialog.preset} onSaved={reg.reload} />
      )}
    </>
  );
};
